const Wrapper = require('./Wrapper');

class UserDataModel {
    constructor() {
        this.name = '';
        this.email = '';
        this.phone = '';
        this.viber = '';
        this.whatsapp = '';
    }
}

class UserDataWrapper extends Wrapper {
    constructor(containerId, model = new UserDataModel()) {
        super();

        this.container = document.getElementById(containerId);

        this.model = model;

        this.initEvents();
    }

    static getModelFromUI() {
        let model = new UserDataModel();

        for(let key in model) {
            model[key] = document.querySelector(`input[name="${key}"]`).value;
        }

        return model;
    }

    validate() {
        this.container.querySelectorAll('input').forEach(input => {
            if(input.checkValidity())
            {
                input.classList.remove('invalid');
            } else {
                input.classList.add('invalid');
            }
        });
    }

    isValid() {
        let inputs = this.container.querySelectorAll('input');

        for(let i = 0; i < inputs.length; i++)
        {
            let input = inputs[i];

            if(!input.checkValidity()) return false;
        }

        return true;
    }

    syncUIWithModel() {
        for(let key in this.model) {
            document.querySelector(`input[name="${key}"]`).value = this.model[key];
        }
    }

    initEvents() {
        $('input').on('change', () => {
            this.updateModel(UserDataWrapper.getModelFromUI());
        })
    }
}

module.exports = UserDataWrapper;